import React from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import Title from "../../Components/Title";
import { MediaQuery } from "react-responsive";
import axios from "axios";
import MobileNavOverlay from "../../Components/Navigation/MobileMenuOverlay";

class WebCemeteriesMapSearch extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            pageData: {
                body: {
                }
            }
        }
    }

    async componentDidMount() {
        const script = document.createElement('script');

        script.src = "https://apps.remembermyjourney.com/map-search/app.js";
        script.async = true;
      
        document.body.appendChild(script);
      
        return () => {
          document.body.removeChild(script);
        };
    }

    render() {
        return (
            <div className="subpage page-wrapper">
                <div className="header-region">
                    <Header />
                </div>
                <div className="body">
                <div id="webcem-map-search" data-key="8yP9DMYqpb3OWJmjnGPKJeQo0r1ALn" data-map="AIzaSyBexKo2vkqIpYlWzyO_-x2OfhA8b2IZOq0" data-cemetery="6BmZ88ow" data-primary="#ffffff" data-secondary="#e9e8e7" data-accent="#a59c94" data-text="#000000"></div>
                    <script async src="https://apps.remembermyjourney.com/map-search/app.js" charset="utf-8"></script>
                    <div id='mobile-menu' style={{display:'none'}}>
                    <MobileNavOverlay />
                </div>
                </div>
                <div id='mobile-menu' style={{display:'none'}}>
                    <MobileNavOverlay />
                </div>
            <div className="footer-region">
                <Footer />
                </div>
                </div>
        );
    }
}

export default WebCemeteriesMapSearch;